export default "__VITE_ASSET__Dli2ChqK__"